<div class="panel panel-custom no-padding custom-panel" [formGroup]="pumpScheduleForm">
    <div class="panel-heading">Liner Job Parameters</div>
    <div class="panel-body">
        <div class="ui-table">
            <table>
                <thead>
                    <tr>
                        <th>Circulation Method above Liner{{ isLinerParamsRequired ? '*' : '' }}</th>
                        <th>Length of Cement above Liner (Gauge Hole){{ isLinerParamsRequired ? '*' : '' }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <p-select formControlName="linerCirculationMethod"
                                [options]="LinerCirculationMethods"
                                placeholder="Choose Circulation Method"
                                [lockableElement]="'Liner_CirculationMethod'">
                            </p-select>
                        </td>
                        <td class="vertical-align-middle">
                            <div class="input-unit" [lockableElement]="'Liner_CementLength'">
                                <input-unit [maxlength]="'6'" [pKeyFilter]="'pint'" formControlName="linerCementLength" unit={{UnitType.Distance}}></input-unit>
                            </div>
                            <div class="custom-unit" dUnitName={{UnitType.Distance}}></div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table>
                <tbody>
                    <tr>
                        <td>
                            <div  class="linear-doc">
                                <span>
                                    General Liner Engineering Guidelines: 
                                    <a (click)="openLinerDocment($event, documentKeyword.GeneralLinear)" class="link-warning">
                                       <u>GD-GL-HAL-CMT-100J</u> 
                                    </a>
                                </span>
                            </div>
                            <div *ngIf="linearConfirmation" class="linear-doc">
                                <span>
                                    Halliburton Expandable Liner Hanger Cementing Guidelines: 
                                    <a (click)="openLinerDocment($event, documentKeyword.ExpandableLinear)" class="link-warning">
                                        <u>WM-GL-HAL-CMT-100K</u>
                                    </a>
                                </span>
                            </div>                            
                        </td>
                    </tr>                    
                </tbody>
            </table>
        </div>
        <div class="panel panel-custom no-padding custom-panel" [formGroup]="versaFlexForm">
            <div class="ui-table">
                <table>
                    <thead>
                        <tr>
                            <th class="versaflex-message">
                                Is This a VersaFlex Liner?{{ isLinerParamsRequired ? '*' : '' }}                            
                            </th>
                            <th *ngIf="(versaFlexForm.controls.isVersaFlexLiner.value && controlPointType == 1)">
                                <span>
                                    Have you communicated the following information to the HCT engineer:
                                    Max Pressure, Pump Rates, Thickening Time (including shutdowns),
                                    Top of Cement, Rathole, and Contingencies? *
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td [ngClass]="(versaFlexForm.controls.isVersaFlexLiner.value && controlPointType == 1) ? 'versaflex-th' : ''">
                                <p-select formControlName="isVersaFlexLiner"
                                    class="versaFlexOptions"
                                    [options]="VersaFlexOptions"
                                    [lockableElement]="'Liner_IsVersaFlex'"
                                    placeholder=" "
                                    (onChange)="isVersaFlexLinearChange()">
                                </p-select>
                            </td>
                            <td *ngIf="(versaFlexForm.controls.isVersaFlexLiner.value && controlPointType == 1)" class="versaflex-td">
                                <div class="versaflex-inner">
                                    <p-checkbox binary="true" class="versaflex-checkbox" 
                                    formControlName="versaFlexLinerConfirmation" inputId="versaFlexLinerConfirmation"
                                    (onChange)="versaFlexConfirmationChange()"></p-checkbox>
                                    <label for="versaFlexLinerConfirmation" class="versaflex-label">Yes</label>
                                    <input type="text" placeholder="Enter Comment Here" class="versaflex-comment" 
                                    formControlName="versaFlexLinerComment"
                                    [class.error-versaflex]="showError()" maxlength="256"
                                    (input)="versaFlexCommentChange()"/>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
         </div>
</div>
